<div class="headrules">
    <h1>Основные правила проекта</h1>
</div>
<div class="rulesblockbg">
    <h1>Общие положение</h1>
    <p>1. На проекте действует прецедентная система правил. (Если игрок совершил правонарушение, которое не описано ни в каких правилах проекта, то он может быть наказан с разрешения ГА. Сделано это не с целью выдумывать правила "на ходу" и наказывать по ним, а потому, что все мы люди, могли что-то и забыть или не учесть).</p>
    <p>2. Проект позиционирует себя как русскоязычный, все РП диалоги должны происходить на русском языке. <b>| Mute 60-240 минут.</b><br><b>Исключение:</b> отдельные слова и фразы для отыгровки роли своего персонажа.</p>
</div>